#import "../../../../editions/graphql/fragments/template-stub-fragment.graphql"
#import "../../../graphql/fragments/edition-fragment.graphql"

fragment TemplateFragment on Campaign {
    ...TemplateStubFragment
    edition {
        ...EditionFragment
    }
}
